module.exports = __webpack_public_path__ + "img/remove_close_1.7ff2f312.png";